export default __webpack_public_path__ + "static/image_media-1da522098486720230b680d8d300e727.gif";